// Simple resolver of API url
// Points to the backend address depending on the url
const apiUrlResolver = () => {
  switch (location.hostname) {
    case "localhost":
      return "http://localhost:8081";
    case "127.0.0.1":
      return "http://127.0.0.1:8081";
    case "test.isotopeticketing.com":
      return "https://api-test.isotopeticketing.com";
    default:
      return "https://api.isotopeticketing.com";
  }
};

// Used mainly for resolving the base name for all url's used in the app
const linkURLResolver = () => {
  switch (location.hostname) {
    case "platform.isotopeticketing.com":
      return "https://platform.isotopeticketing.com";
    case "localhost":
      return "http://localhost:3001";
    case "127.0.0.1":
      return "http://127.0.0.1:3001";
    default:
      return "https://www.isotopeticketing.com";
  }
};

export const AppConfig = {
  apiUrl: apiUrlResolver(),
  hostUrl: linkURLResolver()
};

export const __DEV__ =
  location.hostname === "localhost" || location.hostname === "127.0.0.1";


// WEBPACK FOOTER //
// ./src/config/app.ts